"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../../shared/components/editors/CardRowNumericEditor");
var JackpotTransferEditor = /** @class */ (function (_super) {
    __extends(JackpotTransferEditor, _super);
    function JackpotTransferEditor(props) {
        return _super.call(this, props) || this;
    }
    JackpotTransferEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            transfer_amount: 0,
            transfer_type_code: 0,
            transfer_type_title: "",
            description: ""
        }, function () {
            //this.props.state.setExtBreadCrumbPath(["Новая финансовая операция джекпота"]);
            _this.props.state.setExtBreadCrumbPath(["\u041D\u043E\u0432\u0430\u044F \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u0430\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u0434\u0436\u0435\u043A\u043F\u043E\u0442\u0430 - [" + _this.props.record.title + "]"]);
        });
        this.doReSetRules();
    };
    JackpotTransferEditor.prototype.doReSetRules = function () {
        this.setState({
            transfer_amount_rules: { isError: false },
            transfer_type_rules: { isError: false }
        });
    };
    JackpotTransferEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.transfer_type_code <= 0) || (this.state.transfer_type_title.length === 0)) {
            this.setState({ transfer_type_rules: { isError: true, errorMessage: "Поле [тип операции] не выбрано!" } });
            return false;
        }
        if (this.state.transfer_amount <= 0) {
            this.setState({ transfer_amount_rules: { isError: true, errorMessage: "Поле [сумма операции] заполнено некорректно!" } });
            return false;
        }
        return true;
    };
    JackpotTransferEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                jackpotId: this.props.record.key,
                transferAmount: this.state.transfer_amount,
                transferTypeCode: this.state.transfer_type_code,
                description: this.state.description,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Операция выполнена!");
            });
        }
    };
    JackpotTransferEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack(this.props.record);
        }
    };
    JackpotTransferEditor.prototype.getFormTitle = function () {
        return "Финансовая операция джекпота";
    };
    JackpotTransferEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 350 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип операции:", placeholder: "Выберите тип операции" }, value: { key: this.state.transfer_type_code, value: this.state.transfer_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        transfer_type_code: newVal.key,
                        transfer_type_title: newVal.value,
                        transfer_type_rules: { isError: false }
                    });
                }, items: this.props.availTransferTypes, required: true, rules: this.state.transfer_type_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма операции:", placeholder: "Введите сумму операции" }, values: { max: 99999999, min: 1, value: this.state.transfer_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        transfer_amount: newVal,
                        transfer_amount_rules: { isError: false }
                    });
                }, rules: this.state.transfer_amount_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: false, title: { btnNew: "Выполнить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return JackpotTransferEditor;
}(React.Component));
exports.default = JackpotTransferEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_jackpots/ui/component/transfer_history/JackpotTransferEditor.tsx
// module id = 2349
// module chunks = 0